module.exports = __webpack_public_path__ + "prod/1.42.2/img/affairs-chain.81608d23.png";